"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowRemovedIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _redlineRowRemoved = require("../../../utils/redline-row-removed");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RowRemovedIndicator = exports.RowRemovedIndicator = function RowRemovedIndicator(_ref) {
  var removedBy = _ref.removedBy;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "flex items-center gap-1 text-[11px] font-medium text-[#92400E]",
    role: "status",
    "data-sentry-component": "RowRemovedIndicator",
    "data-sentry-source-file": "RowRemovedIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 13,
      height: 13,
      className: "flex-shrink-0",
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "RowRemovedIndicator.tsx"
    }), (0, _redlineRowRemoved.rowRemovedLabelOf)(removedBy)]
  });
};